export default __webpack_public_path__ + "static/grenette-bold-italic-pro-84f7db3da4c023aa7e3c5031e1730c16.woff2";